export async function fetchCloud(body: any) {
  // Return mock data in development environment
  if (import.meta.env.DEV && typeof window !== 'undefined' && !window.Cypress) {
    // Mock response based on the GraphQL query
    const query = typeof body === 'string' ? JSON.parse(body).query : body.query

    if (query.includes('me {')) {
      return {
        data: {
          me: {
            id: '123',
            email: 'test@cypress.io',
            firstName: 'Test',
            lastName: 'User',
            isPayingUser: true,
            organizations: {
              nodes: [
                { id: '1', name: 'Acme 1' },
                { id: '2', name: 'Acme 2' },
              ],
            },
          },
        },
      }
    }

    // Default mock response if query isn't handled
    return { data: {} }
  }

  // when testing lighthouse we want to avoid errors polluting the reports
  // we also want to focus on actual work on localhost
  if (
    import.meta.env.MODE !== 'cloud_debug' &&
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') &&
    !window.Cypress // allow cy.intercept to fake the request in CI but skip on lighthouse & in dev mode
  ) {
    return {}
  }

  const cloudUrl = import.meta.env.SSR ? import.meta.env.SERVER_CLOUD_URL : import.meta.env.PUBLIC_CLOUD_URL

  const response = await fetch(`${cloudUrl}/graphql`, {
    mode: `cors`,
    method: `POST`,
    credentials: `include`,
    headers: { 'Content-Type': `application/json;charset=UTF-8` },
    body: typeof body === `string` ? body : JSON.stringify(body),
  })

  return response.json()
}
